import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["category", { selected: _ctx.isSelected }]),
    style: _normalizeStyle({ 'background-color': _ctx.backgroundColor })
  }, [
    _createElementVNode("div", null, _toDisplayString(_ctx.icon), 1),
    _createElementVNode("div", null, _toDisplayString(_ctx.title), 1)
  ], 6))
}